module.exports = __webpack_public_path__ + "static/media/blog_54.4d144a91.webp";